import requestData, {formatterData, middleErrorInfo, setURLSearchParams} from "../../../http/request";
const thisFileName = `CompanyRequest.js`;
export const searchCompany = ({token=''}) =>{
  if(!String(token)) return Promise.reject(formatterData({
    errorMessage:'Token不能为空',
  }));
  const params = setURLSearchParams({
    keyValueObject:{
      ust:token,
    }
  });
  return new Promise(((resolve, reject) => {
    requestData('/company/index','POST',params).then(value => {
      if(Number(value.data.code)!==1) return resolve(formatterData({
        errorMessage:'获取公司身份信息失败',
      }));
      const valueData = value.data.data[0];
      resolve(formatterData({
        status:200,
        dataItem:{
          id:valueData.Id,
          cityCode:valueData.cityCode,
          companyFullName:valueData.fullName,
        },
      }))
    }).catch(reason => {
      console.trace(`${middleErrorInfo} ${thisFileName} searchCompany: ${JSON.stringify((reason))}`);
      reject(formatterData({
        dataItem:{reason,}
      }));
    });
  }));
}
export const getProvinceInfo = ({token='',code=''}) => {
  if(!String(code) || !Number(code)) return Promise.resolve(formatterData({
    errorMessage:'没有获取到地区代码',
  }));
  return new Promise((resolve, reject) => {
    const params = setURLSearchParams({
      keyValueObject:{
        ust:token,
        arg:code,
      }
    });
    requestData('/public/getProvinceInfo','POST',params).then(value => {
      if(Number(value.data.code)!==1) return Promise.resolve(formatterData({
        errorMessage:'获取省市区信息失败，请重试',
      }));
      resolve(formatterData({
        status:200,
        dataItem:{
          province:{
            id:value.data.data.province.dt_id,
            name:value.data.data.province.dt_name,
          },
          city:{
            id:value.data.data.city.dt_id,
            name:value.data.data.city.dt_name,
          },
          county:{
            id:value.data.data.area.dt_id,
            name:value.data.data.area.dt_name,
          },
        },
      }));
    }).catch(reason => {
      console.trace(`${middleErrorInfo} ${thisFileName} getProvinceInfo: ${JSON.stringify((reason))}`);
      reject(formatterData({
        dataItem:{reason,}
      }));
    });
  });
}
